import React from 'react'
import classnames from 'classnames'

import "./PlayerScrubber.css"

class PlayerScrubber extends React.PureComponent {

	static propTypes = {}
	static defaultProps = {}

	constructor( props ) {
		super(props)
		this.state = { selected: false }
		this.onMouseDown = this.onMouseDown.bind(this)
		this.onMouseUp = this.onMouseUp.bind(this)
	}

	onMouseDown() {
		this.setState({ selected: true })
	}

	onMouseUp() {
		this.setState({ selected: false })
	}

	render() {
		const className = classnames('player__scrubber', {
			'player__scrubber--selected': this.state.selected
		})
		return (
			<div className={ className }
				onMouseDown={ this.onMouseDown }
				onMouseUp={ this.onMouseUp }
			/>
		)
	}
}

export default PlayerScrubber


// WEBPACK FOOTER //
// ./src/components/player/controls/scrubber/PlayerScrubber.jsx